{
  "annotations": "Annotations",
  "ask": "Ask in chat",
  "askAbout": "Ask in chat about {{name}}",
  "chips": "Sent with your message",
  "documentText": "Document text",
  "edit": "Edit",
  "entry": "Run entry #{{number}}",
  "newThread": "New run beside",
  "remove": "Remove {{name}}",
  "selection": "Selected text",
  "sentTo": "In the chat of {{threads}}",
  "show": "Show",
  "statements": "Statements",
  "waiting": "Waiting: no open Run takes messages",
  "withFork": "Fork this Run to send them with your first message."
}
